var React = require('react');

function TimelineTrailOne (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 2C16.5 32 59.4 93 135 97C229.5 102 214.276 184.538 164.5 203.5C101.5 227.5 89.5 338 265.5 292.5","stroke":"#242424","strokeOpacity":"0.56","strokeWidth":"8","strokeDasharray":"16 16"}));
}

TimelineTrailOne.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 267 308","fill":"none"};

module.exports = TimelineTrailOne;

TimelineTrailOne.default = TimelineTrailOne;
